import React from 'react';

import styles from './styles/CameraCaptureNavigation.module.css';

export type CameraOrientation = 'portrait' | 'landscapeLeft' | 'landscapeRight';

interface LiveModeProps {
	mode: 'live';
	orientation: CameraOrientation;
	onClose: () => void;
	onCapture: () => void;
	isCaptureDisabled: boolean;
	hasOverlayToggle: boolean;
	isOverlayVisible: boolean;
	onToggleOverlay: () => void;
}

interface PreviewModeProps {
	mode: 'preview';
	orientation: CameraOrientation;
	onDeny: () => void;
	onAccept: () => void;
}

type CameraCaptureNavigationProps = LiveModeProps | PreviewModeProps;

export const CameraCaptureNavigation: React.FC<CameraCaptureNavigationProps> = (props) => {
	const isLandscape = props.orientation !== 'portrait';
	const barClass = `${styles.buttonBar}${isLandscape ? ` ${styles.landscape}` : ''}`;

	if (props.mode === 'preview') {
		return (
			<div className={barClass}>
				<div className={`${styles.barSection} ${styles.barSectionStart}`}>
					<button className={styles.closeButton} onClick={props.onDeny}>
						<img className={styles.denyIcon} src="icons/azcee/Close-Button.svg" alt="deny" />
					</button>
				</div>
				<div className={`${styles.barSection} ${styles.barSectionEnd}`}>
					<button className={styles.acceptButton} onClick={props.onAccept}>
						<img className={styles.acceptIcon} src="icons/azcee/Check.svg" alt="accept" />
					</button>
				</div>
			</div>
		);
	}

	return (
		<div className={barClass}>
			<div className={`${styles.barSection} ${styles.barSectionStart}`}>
				<button className={styles.closeButton} onClick={props.onClose}>
					<img className={styles.denyIcon} src="icons/azcee/Close-Button.svg" alt="close" />
				</button>
			</div>
			<button className={styles.captureButton} onClick={props.onCapture} />
			<div className={`${styles.barSection} ${styles.barSectionEnd}`}>
				{props.hasOverlayToggle && (
					<button
						className={`${styles.toggleSwitch}${props.isOverlayVisible ? ` ${styles.active}` : ''}`}
						onClick={props.onToggleOverlay}
					>
						<div
							className={`${styles.toggleDot}${props.isOverlayVisible ? ` ${styles.active}` : ''}`}
						/>
					</button>
				)}
			</div>
		</div>
	);
};
